module.exports = __webpack_public_path__ + "img/course.e5d32c99.png";